import { render, staticRenderFns } from "./addProject.vue?vue&type=template&id=27d494c0&scoped=true&"
import script from "./addProject.vue?vue&type=script&lang=js&"
export * from "./addProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d494c0",
  null
  
)

export default component.exports